// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1INhb","title":"Header_title__144ag","left":"Header_left__2nwTO","clinicName":"Header_clinicName__3-RPw"};